import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";
import {BATCH_COLORS} from "../../BATCH_COLORS";

@Component({
    selector: 'app-app-region-batch-bar-chart',
    templateUrl: './app-region-batch-bar-chart.component.html',
    styleUrls: ['./app-region-batch-bar-chart.component.scss']
})
export class AppRegionBatchBarChartComponent implements OnInit {
    private _appForRegion: any;

    get appForRegion() {
        return this._appForRegion;
    }

    @Input() set appForRegion(val: any) {
        this._appForRegion = val;
        if (val) {
            this.chartAppBatchForRegion = {
                series: this._appForRegion.dayBatchData.series,
                chart: {
                    type: "bar",
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    width: '100%',
                    height: '100%',
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: false
                    }
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            legend: {
                                position: "bottom",
                                offsetX: -10,
                                offsetY: 0
                            }
                        }
                    }
                ],
                plotOptions: {
                    bar: {
                        horizontal: false
                    }
                },
                xaxis: {
                    type: "category",
                    categories: this._appForRegion.dayBatchData.labels
                },
                legend: {
                    position: "top",
                    // offsetY: 40
                },
                fill: {
                    opacity: 1
                },
                colors: BATCH_COLORS,
            };

        }
    }

    chartAppBatchForRegion: ApexOptions;

    constructor() {
    }

    ngOnInit(): void {
    }

}
